import controller from './chart-humidity.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    controller,
    template
};
